import { fieldEvidenceOptions } from '../field-object-labels';

import { FIELD_LABEL } from './field-types';

import type { FieldSnapshot } from '@mio/shared';

export function FieldChoiceList({
  label,
  options,
  value,
  onChange,
  max = 30,
  disabled = false,
  empty,
}: {
  label: string;
  options: { id: string; label: string }[];
  value: string[];
  onChange: (value: string[]) => void;
  max?: number;
  disabled?: boolean;
  empty?: string;
}) {
  return (
    <fieldset disabled={disabled}>
      <legend className={FIELD_LABEL}>{label}</legend>
      {options.length ? (
        <div className="field-discovery-choices">
          {options.map((option) => (
            <label key={option.id} className="field-object-choice">
              <input
                type="checkbox"
                checked={value.includes(option.id)}
                disabled={!value.includes(option.id) && value.length >= max}
                onChange={(event) =>
                  onChange(
                    event.target.checked
                      ? [...value, option.id]
                      : value.filter((id) => id !== option.id),
                  )
                }
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      ) : (
        <p className="text-fg-muted text-sm leading-6">{empty ?? 'No references available yet.'}</p>
      )}
      {value.length >= max ? (
        <p className="text-fg-muted mt-2 text-xs">Up to {max} references per record.</p>
      ) : null}
    </fieldset>
  );
}

export function FieldEvidencePicker({
  snapshot,
  value,
  onChange,
  excludeId,
  disabled,
}: {
  snapshot: FieldSnapshot;
  value: string[];
  onChange: (value: string[]) => void;
  excludeId?: string;
  disabled?: boolean;
}) {
  return (
    <FieldChoiceList
      label="Supporting evidence"
      options={fieldEvidenceOptions(snapshot, excludeId)}
      value={value}
      onChange={onChange}
      disabled={disabled ?? false}
      empty="Reference a conversation, document, or verified result as your understanding develops."
    />
  );
}
